/**
 * Catch-all route for 404 Not Found
 * 
 * This route handles all unmatched paths and displays a 404 error page.
 * Following TanStack Router conventions, the `$` file creates a catch-all route.
 */
import { createFileRoute, Link } from '@tanstack/react-router';
import { InfoIcon, Home } from 'lucide-react';
import { Button } from '@loader/ui';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@loader/ui';

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
});

/**
 * 404 Not Found Page Component
 * 
 * Displays a user-friendly error message when a page is not found.
 * Rendered outside of AppShell (no sidebar).
 */
function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
            <InfoIcon className="h-8 w-8 text-muted-foreground" />
          </div>
          <CardTitle className="text-3xl font-bold">404</CardTitle>
          <CardDescription className="text-lg">
            Page Not Found
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex justify-center gap-2">
            <Button asChild variant="default">
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Go Home
              </Link>
            </Button>
            <Button
              variant="outline"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

